



































import Vue from "vue"
import SectionTitle from "~/components/guideline/util/SectionTitleWithIcon.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"

export default Vue.extend({
  components: {
    SectionTitle,
    ConversionButton,
  },
  methods: {
    handleClickSignupButton() {
      this.$emit("click-signup-button")
    },
    handleClickLoginButton() {
      this.$emit("click-login-button")
    },
  },
})
